import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/subscriptions/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getFailedSubscriptionListData = async (
  params = '',
  signal = null
) => {
  const options = prepareRequestOptions(
    `/admin/failed-subscriptions/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const viewFailedSubscriptionDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/failed-subscriptions/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getCancelSubscriptionRequestListData = async (
  params = '',
  signal = null
) => {
  const options = prepareRequestOptions(
    `/admin/cancel-subscription-request/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const viewCancelSubscriptionRequestDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/cancel-subscription-request/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const cancelSubscriptionById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/${id}/cancel`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getListDataBySubscriber = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/subscriber-coupon-codes/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};
